import React from 'react';
import { IconProps } from './types';

const PlayOutline: React.FC<IconProps> = ({
  className,
  size = 32,
  color,
  ignoreColor,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 45C12.425 45 3 35.575 3 24S12.425 3 24 3s21 9.425 21 21-9.425 21-21 21zm0-40C13.525 5 5 13.525 5 24s8.525 19 19 19 19-8.525 19-19S34.475 5 24 5z"
      fill={!ignoreColor ? color : undefined}
    />
    <path
      d="M17 37.887V10.112L37.5 24 17 37.887zm2-24v20.225L33.938 24 19 13.887z"
      fill={!ignoreColor ? color : undefined}
    />
  </svg>
);

export default PlayOutline;
